import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import DriversProfilePage from "./DriversProfilePage.jsx";

export default function DriverProfileRoute() {
    const { driverSlug, driverId } = useParams();
    const [searchParams] = useSearchParams();

    return (
        <DriversProfilePage
            driverSlug={driverSlug || driverId}
            seasonKey={searchParams.get("season") || "active"}
        />
    );
}